export const LOADING_SLIDE_DETAILS = "LOADING_SLIDE_DETAILS";
export const SUCCESS_DOWNLOAD_DECK = "SUCCESS_DOWNLOAD_DECK";

export const DownloadDeckTypes = {
	LOADING_SLIDE_DETAILS,
	SUCCESS_DOWNLOAD_DECK
}